//TODO take from from env
// export const endpoint = 'http://localhost:4000/saas/';\\

export const methods = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: 'PATCH',
}